import React from "react";
import { Printer } from "lucide-react";

const Box = ({ label, value }) => (
  <div className="rounded-xl bg-white/8 border border-white/15 p-3">
    <div className="text-[11px] text-white/55">{label}</div>
    <div className="text-xl font-black mt-1" style={{ color: "var(--play-accent)" }}>{value}</div>
  </div>
);

export const ClassReport = ({ report }) => {
  if (!report) return <p className="text-white/55 text-sm" data-testid="report-loading">...جارٍ التحميل</p>;
  return (
    <div className="space-y-5" data-testid="class-report">
      <div className="flex items-center justify-between gap-3">
        <div>
          <h3 className="text-lg font-black">{report.class_name} · الصف {report.grade}</h3>
          <p className="text-xs text-white/50">{report.generated_at?.slice(0, 16).replace("T", " ")}</p>
        </div>
        <button onClick={() => window.print()} data-testid="print-report-btn"
          className="pro-btn bg-white/12 text-white border border-white/20 text-xs flex items-center gap-1">
          <Printer size={13} />طباعة</button>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
        <Box label="الطلاب" value={report.students} />
        <Box label="النشطون" value={report.active_students} />
        <Box label="متوسط النقاط" value={report.avg_points} />
        <Box label="متوسط الكويز" value={`${report.avg_quiz_score}%`} />
        <Box label="متوسط محطات الرحلة" value={report.avg_stage} />
        <Box label="الحلول المُسلّمة" value={report.total_submissions} />
      </div>

      {!!report.class_weak_words.length && (
        <div data-testid="report-weak-words">
          <h4 className="font-black text-sm mb-2">أصعب الكلمات على الفصل (أعِد شرحها)</h4>
          <div className="flex flex-wrap gap-2">
            {report.class_weak_words.map((w) => (
              <span key={w.word} className="rounded-full px-3 py-1 text-xs font-bold"
                style={{ background: "rgba(255,93,93,.18)", color: "#ffb0b0" }} dir="ltr">
                {w.word} · {w.misses}</span>
            ))}
          </div>
        </div>
      )}

      <div className="grid sm:grid-cols-2 gap-4">
        <div data-testid="report-top">
          <h4 className="font-black text-sm mb-2">الأفضل في الفصل 🏆</h4>
          <ol className="space-y-1 ps-5 list-decimal text-sm">
            {report.top.map((r) => <li key={r.id}>{r.name} — {r.points} نقطة</li>)}
          </ol>
        </div>
        <div data-testid="report-needs-help">
          <h4 className="font-black text-sm mb-2">يحتاجون متابعة</h4>
          <ul className="space-y-1 ps-5 list-disc text-sm text-white/80">
            {report.needs_help.map((r) => <li key={r.id}>{r.name} — {r.points} نقطة</li>)}
            {!report.needs_help.length && <li className="text-white/45">لا أحد متأخر 👍</li>}
          </ul>
        </div>
      </div>

      <div className="overflow-x-auto">
        <table className="pro" data-testid="report-rows">
          <thead><tr><th>الطالب</th><th>النقاط</th><th>كويزات</th><th>متوسط الكويز</th>
            <th>مهام</th><th>محطة</th><th>كلمات صعبة</th></tr></thead>
          <tbody>
            {report.rows.map((r) => (
              <tr key={r.id} data-testid={`class-report-row-${r.username}`}>
                <td className="font-bold">{r.name}</td><td>{r.points}</td><td>{r.quizzes}</td>
                <td>{r.avg_score}%</td><td>{r.submissions}</td><td>{r.stage}</td><td>{r.weak_count}</td>
              </tr>
            ))}
            {!report.rows.length && <tr><td colSpan="7" className="text-white/45">لا طلاب في هذا الفصل</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
};
